import { QuoteProductLine } from "./QuoteProductLine";

export class StartQuoteRequest {
    constructor(productLines?: Array<QuoteProductLine>, agentCode?: string, subProducerAgentId?: string, utmCampaign?: string, sourcePagePath?: string) {
        this.selectedProductLines = productLines || [];
        this.agentCode = agentCode;
        this.subProducerAgentId = subProducerAgentId;
        this.utmCampaign = utmCampaign;
        this.sourcePagePath = sourcePagePath;
    }

    selectedProductLines: Array<QuoteProductLine>;
    agentCode: string;
    subProducerAgentId: string;
    utmCampaign;
    sourcePagePath;
}
